import _ from 'lodash';

import { TAGS } from 'common/constants/vendors';
import {
    templateValidator,
    oldTemplateValidator,
    clickMacroValidator,
} from 'common/richmedia-validators';
import { regEx } from 'utils/regular-expression-library';
import {
    isVendorForCreativeTesting,
    SIZES_NOT_SUPPORTED_BY_SIMULATOR,
} from 'states/resources/creatives/business-logic';

const urlValidationRegExp = regEx.url;
const ENGAGEFRONT_JS_TAG_MATCHER = _.find(TAGS, { value: 'engagefront__tag__js' }).test;

export const mraidValidators = {
    content_html(value) {
        if (!value) {
            return 'HTML Markup is required';
        }

        const clickMacroErrorMessage = clickMacroValidator(value);
        if (clickMacroErrorMessage) {
            return clickMacroErrorMessage;
        }

        const isNewCreativeTemplate = null !== value.match(/\<ef\-creative/gim);

        const hasMoreThanAscii = [...value].some(char => char.charCodeAt(0) > 127);

        if (hasMoreThanAscii) {
            return 'HTML Markup has Invalid non-ASCII characters';
        }

        if (!ENGAGEFRONT_JS_TAG_MATCHER(value)) {
            return;
        }

        return isNewCreativeTemplate ? templateValidator(value) : oldTemplateValidator(value);
    },
    reference_image_asset() {
        // optional
    },
    reference_image_preview_url(value, source) {
        if (!value && !source.reference_image_asset) {
            return 'Reference Screenshot is required';
        }

        if (!urlValidationRegExp.test(value)) {
            return `Reference Screenshot should start with 'http://', 'https://', or 'tel:'`;
        }
    },
    third_party_clickthrough(value) {
        if (!_.isBoolean(value)) {
            return 'Third Party Clickthrough is required';
        }
    },
    clickthrough_url(value, source) {
        if (!value && source.third_party_clickthrough === true) {
            return 'Clickthrough URL is required';
        }

        if (!urlValidationRegExp.test(value)) {
            return `Clickthrough URL should start with 'http://', 'https://', or 'tel:'`;
        }
    },
    simulator_verification_acknowledged(value, source) {
        if (isVendorForCreativeTesting(source) && !value) {
            return SIZES_NOT_SUPPORTED_BY_SIMULATOR.includes(source.size)
                ? 'Please verify that you have tested the creative behaviour'
                : 'Please verify that you have tested the creative behaviour using the simulator on the right';
        }
    },
    landing_page(value, source) {
        if (!value) {
            return 'Landing Page is required';
        }

        if (value === source.clickthrough_url && source.third_party_clickthrough === true) {
            return 'Landing Page cannot be the same as Clickthrough URL';
        }

        if (!urlValidationRegExp.test(value)) {
            return `Landing Page should start with 'http://', 'https://', or 'tel:'`;
        }
    },
    creative_vendors(value) {
        if (!value.length) {
            return 'A creative vendor must be specified';
        }
    },
    third_party_pixels(value) {
        if (value === undefined) {
            return;
        }

        if (!_.isArray(value)) {
            throw new Error('Expected third_party_pixels to be a list');
        }

        const allValid = _.every(value, pixel => urlValidationRegExp.test(pixel));

        if (!allValid) {
            return `Third Party Pixels should start with 'http://', 'https://', or 'tel:'`;
        }
    },
    third_party_javascript_urls(value) {
        if (value === undefined) {
            return;
        }

        if (!_.isArray(value)) {
            throw new Error('Expected third_party_javascript_urls to be a list');
        }

        const allValid = _.every(value, pixel => urlValidationRegExp.test(pixel));

        if (!allValid) {
            return `Third Party JavaScript should start with 'http://', 'https://', or 'tel:'`;
        }
    },
};
